import { History, Location } from 'history';
import * as React from 'react';

import { mergeQueryString, SerializedData, updateSearch } from 'bernie-core';

import { ActivitySearchStore } from '../../../stores';

import { getFilteredObjectKeys } from '../../../helpers/common-helper';

import { getCheckboxKeyAndId } from '../../../components/srp/sort-filter/checkbox';
import { getUpdatedFilterQueryObject, SEE_ALL_CATEGORY } from '../../../components/srp/sort-filter/filter-helper';

const getFirstAndLastIndices = (updatedFilterState: SerializedData, keys: string[]): SerializedData => {
  let startIndex = -1;
  let endIndex = -1;

  keys.forEach((key: string, index: number) => {
    if (updatedFilterState[key].selected && updatedFilterState[key].enabled) {
      if (startIndex === -1) {
        startIndex = index;
      } else {
        endIndex = index;
      }
    }
  });

  return { startIndex, endIndex };
};

const updateRangeFilterState = (
  filterCategoryId: string,
  filterKey: string,
  checked: boolean,
  activitySearchStore: ActivitySearchStore
): SerializedData => {
  const updatedFilterState = activitySearchStore.sortAndFilterObject.filters;
  updatedFilterState[filterCategoryId][filterKey] = { selected: checked, enabled: true };
  const filterKeys = getFilteredObjectKeys(updatedFilterState[filterCategoryId]);
  const { startIndex, endIndex } = getFirstAndLastIndices(updatedFilterState[filterCategoryId], filterKeys);

  if (startIndex !== -1 && endIndex !== -1) {
    for (let i = startIndex + 1; i < endIndex; i++) {
      updatedFilterState[filterCategoryId][filterKeys[i]].selected = true;
      updatedFilterState[filterCategoryId][filterKeys[i]].enabled = false;
    }
  } else if (startIndex !== -1) {
    for (let i = 0; i < filterKeys.length; i++) {
      if (i !== startIndex) {
        updatedFilterState[filterCategoryId][filterKeys[i]].selected = false;
        updatedFilterState[filterCategoryId][filterKeys[i]].enabled = true;
      }
    }
  }

  return updatedFilterState;
};

export function rangeCheckboxClickHandler(
  activitySearchStore: ActivitySearchStore,
  event: React.ChangeEvent<HTMLInputElement>,
  history: History,
  location: Location,
  inDialog?: boolean
): void {
  const { filterKey, filterCategoryId } = getCheckboxKeyAndId(event.target.id);
  const checked = event.target.checked;
  const updatedFilterState = updateRangeFilterState(filterCategoryId, filterKey, checked, activitySearchStore);
  if (checked && updatedFilterState[SEE_ALL_CATEGORY]) {
    updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = { selected: !checked, enabled: true };
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    const newQueryString = mergeQueryString(location.search, {
      ...getUpdatedFilterQueryObject(activitySearchStore),
    });
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true,
    });
  }
}
